/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { CardsComponentEditor } from "cms/components/components/cards/edit";
import { CardsComponentDisplay } from "cms/components/components/cards/display";
import { getComponentZoneLayout } from "cms/components/components/component";

const CardsComponent = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <CardsComponentDisplay />,
        editComponent: <CardsComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

CardsComponent.displayName = "CardsComponent";
export { CardsComponent };
